import {createRouter, createWebHistory} from 'vue-router'
import HomePageOne from '../views/home/HomePageOne'
import HomePageTwo from '../views/home/HomePageTwo'
import HomePageThree from '../views/home/HomePageThree'
import HomePageFour from '../views/home/HomePageFour'
import HomePageFive from '../views/home/HomePageFive'
import HomePageSix from '../views/home/HomePageSix'
import HomePageSeven from '../views/home/HomePageSeven'
import HomePageEight from '../views/home/HomePageEight'
import HomePageNine from '../views/home/HomePageNine'
import CreateProduct from '../views/CreateProduct'
import ProductDetails from '../views/ProductDetails'
import Connect from '../views/Connect'
import Collection from '../views/Collection'
import Creators from '../views/Creators'
import AuthorDetails from '../views/AuthorDetails'
import EditProfilePage from '../views/EditProfilePage'
import About from '../views/About'
import Contact from '../views/Contact'
import BlogDetails from '../views/blog/BlogDetails'
import BlogCategoryPosts from '../views/blog/BlogCategoryPosts'
import BlogTagPosts from '../views/blog/BlogTagPosts'
import BlogSingleColumn from '../views/blog/BlogSingleColumn'
import BlogTwoColumn from '../views/blog/BlogTwoColumn'
import BlogThreeColumn from '../views/blog/BlogThreeColumn'
import BlogFourColumn from '../views/blog/BlogFourColumn'
import ExploreOne from '../views/ExploreOne'
import ExploreTwo from '../views/ExploreTwo'
import ExploreThree from '../views/ExploreThree'
import ExploreFour from '../views/ExploreFour'
import ExploreFive from '../views/ExploreFive'
import ExploreSix from '../views/ExploreSix'
import ExploreSeven from '../views/ExploreSeven'
import ExploreEight from '../views/ExploreEight'
import ExploreNine from '../views/ExploreNine'
import ExploreTen from '../views/ExploreTen'
import ExploreEleven from '../views/ExploreEleven'
import ExploreTwelve from '../views/ExploreTwelve'
import ExploreThirteen from '../views/ExploreThirteen'
import UploadVariants from '../views/UploadVariants'
import Activity from '../views/Activity'
import UpcomingProjects from '../views/UpcomingProjects'
import Login from '../views/Login'
import Signup from '../views/Signup'
import ForgetPassword from '../views/ForgetPassword'
import PrivacyPolicy from '../views/PrivacyPolicy'
import Products from '../views/Products'
import Ranking from '../views/Ranking'
import NotFound from '../views/NotFound'
import Support from '../views/Support'
import TermsCondition from '../views/TermsCondition'
import ComingSoon from '../views/ComingSoon'
import Maintenance from '../views/Maintenance'

const routes = [
    {
        path: '/',
        name: 'HomePageOne',
        component: HomePageOne,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-02',
        name: 'HomePageTwo',
        component: HomePageTwo,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-03',
        name: 'HomePageThree',
        component: HomePageThree,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-04',
        name: 'HomePageFour',
        component: HomePageFour,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-05',
        name: 'HomePageFive',
        component: HomePageFive,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-06',
        name: 'HomePageSix',
        component: HomePageSix,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-07',
        name: 'HomePageSeven',
        component: HomePageSeven,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-08',
        name: 'HomePageEight',
        component: HomePageEight,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/index-09',
        name: 'HomePageNine',
        component: HomePageNine,
        meta: {
            title: 'xSTH - NFT Marketplace',
        },
    },
    {
        path: '/create',
        name: 'CreateProduct',
        component: CreateProduct,
        meta: {
            title: 'Create || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/product/:id',
        name: 'ProductDetails',
        component: ProductDetails,
        meta: {
            title: 'Product Details || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/connect',
        name: 'Connect',
        component: Connect,
        meta: {
            title: 'Connect || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/collection',
        name: 'Collection',
        component: Collection,
        meta: {
            title: 'Author || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/creator',
        name: 'Creators',
        component: Creators,
        meta: {
            title: 'Collection || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/author/:id',
        name: 'AuthorDetails',
        component: AuthorDetails,
        meta: {
            title: 'Author Details || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/edit-profile',
        name: 'EditProfilePage',
        component: EditProfilePage,
        meta: {
            title: 'Edit Profile || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: 'About || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            title: 'Contact || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/category/:slug',
        name: 'BlogCategoryPosts',
        component: BlogCategoryPosts,
        meta: {
            title: 'Blog Category List || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/tag/:slug',
        name: 'BlogTagPosts',
        component: BlogTagPosts,
        meta: {
            title: 'Blog Tag List || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/blog-details/:id',
        name: 'BlogDetails',
        component: BlogDetails,
        meta: {
            title: 'Blog Details || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/blog-single-column',
        name: 'BlogSingleColumn',
        component: BlogSingleColumn,
        meta: {
            title: 'Blog Single Column || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/blog-col-two',
        name: 'BlogTwoColumn',
        component: BlogTwoColumn,
        meta: {
            title: 'Blog Two Column || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/blog-col-three',
        name: 'BlogThreeColumn',
        component: BlogThreeColumn,
        meta: {
            title: 'Blog Three Column || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/blog',
        name: 'BlogFourColumn',
        component: BlogFourColumn,
        meta: {
            title: 'Blog Four Column || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-01',
        name: 'ExploreOne',
        component: ExploreOne,
        meta: {
            title: 'Explore Filter || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-02',
        name: 'ExploreTwo',
        component: ExploreTwo,
        meta: {
            title: 'Explore Isotop || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-03',
        name: 'ExploreThree',
        component: ExploreThree,
        meta: {
            title: 'Explore Carousel || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-04',
        name: 'ExploreFour',
        component: ExploreFour,
        meta: {
            title: 'Explore Simple || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-05',
        name: 'ExploreFive',
        component: ExploreFive,
        meta: {
            title: 'Explore With Place Bid || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-06',
        name: 'ExploreSix',
        component: ExploreSix,
        meta: {
            title: 'Place Bid With Filter || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-07',
        name: 'ExploreSeven',
        component: ExploreSeven,
        meta: {
            title: 'Place Bid With Carousel || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-08',
        name: 'ExploreEight',
        component: ExploreEight,
        meta: {
            title: 'Explore Carousel || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-09',
        name: 'ExploreNine',
        component: ExploreNine,
        meta: {
            title: 'Explore List Style || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-10',
        name: 'ExploreTen',
        component: ExploreTen,
        meta: {
            title: 'Explore List Column Two || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-11',
        name: 'ExploreEleven',
        component: ExploreEleven,
        meta: {
            title: 'Live Explore || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-12',
        name: 'ExploreTwelve',
        component: ExploreTwelve,
        meta: {
            title: 'Live Explore Carousel || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/explore-13',
        name: 'ExploreThirteen',
        component: ExploreThirteen,
        meta: {
            title: 'Live With Place Bid || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/upload-variants',
        name: 'UploadVariants',
        component: UploadVariants,
        meta: {
            title: 'Upload Variants || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/activity',
        name: 'Activity',
        component: Activity,
        meta: {
            title: 'Activity || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/upcoming-projects',
        name: 'UpcomingProjects',
        component: UpcomingProjects,
        meta: {
            title: 'Upcoming Projects || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'Login || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/sign-up',
        name: 'Signup',
        component: Signup,
        meta: {
            title: 'Signup || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/forget',
        name: 'ForgetPassword',
        component: ForgetPassword,
        meta: {
            title: 'Forget Password || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
            title: 'Privacy Policy || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/product',
        name: 'Products',
        component: Products,
        meta: {
            title: 'Product || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/ranking',
        name: 'Ranking',
        component: Ranking,
        meta: {
            title: 'Ranking || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: '404 || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/support',
        name: 'Support',
        component: Support,
        meta: {
            title: 'Ranking || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/terms-condition',
        name: 'TermsCondition',
        component: TermsCondition,
        meta: {
            title: 'Terms & Condition || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon,
        meta: {
            title: 'Coming Soon || xSTH - NFT Marketplace',
        },
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        meta: {
            title: 'Maintenance || xSTH - NFT Marketplace',
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
